var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.73285 22.1667C3.73285 20.8052 4.27368 19.4996 5.23637 18.5369C6.19905 17.5742 7.50474 17.0334 8.86618 17.0334H19.1328C20.4943 17.0334 21.8 17.5742 22.7627 18.5369C23.7253 19.4996 24.2662 20.8052 24.2662 22.1667C24.2662 22.8474 23.9958 23.5003 23.5144 23.9816C23.0331 24.4629 22.3802 24.7334 21.6995 24.7334H6.29952C5.61879 24.7334 4.96595 24.4629 4.48461 23.9816C4.00326 23.5003 3.73285 22.8474 3.73285 22.1667Z",
    stroke: "#647C8F",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.9C16.1263 11.9 17.85 10.1763 17.85 8.05001C17.85 5.92372 16.1263 4.20001 14 4.20001C11.8737 4.20001 10.15 5.92372 10.15 8.05001C10.15 10.1763 11.8737 11.9 14 11.9Z",
    stroke: "#647C8F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/icUser.18b36919bf9b2e7bf5596e65ebd11af8.svg";
export { ForwardRef as ReactComponent };